






import Vue from 'vue'
import { toggleValue } from '../store/actions';
import { routerReplace } from '../helpers';


interface CheckboxMethods {
	valueToggled(event: any): void
}

interface CheckboxProperty {
	name: string,
    value: string,
    index: string,
    selected: boolean
}
interface CheckboxComputed {
    selected: boolean
}

export default Vue.extend<{}, CheckboxMethods, CheckboxComputed, CheckboxProperty>({
	name: 'Checkbox',
	props: {
		name: {},
        value: {},
        selected: {},
        index: {}
	},
    computed: {
        selected: {
            get() {
                const filter = this.$store.getters.categoryFilter.find((cf: any) => cf.name === this.$props.name);
                if(filter) {
                    const value = filter.values.find((f: any) => f.value === this.$props.value);
                    return value.selected;
                }
                return false
            },
            set(value) {
                this.$store.dispatch(toggleValue({
                    value: {
                        name: this.$props.name,
                        value: this.$props.value,
                        selected: value
                    }
                }))
                routerReplace({
				    query: this.$store.getters.getParams
			    })
            }
        }
    }
})
